import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=2fd3b691"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"
import style0 from "../../components/BankInformation/bkCuenta.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../components/Cuenta/cuentaMenu.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./Conversation.vue?vue&type=style&index=2&id=2fd3b691&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports